"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ajv = _interopRequireDefault(require("ajv"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const COMPONENTS_SCHEMA = {
  type: ['object', 'null'],
  additionalProperties: {
    type: 'object',
    properties: {
      enabled: {
        type: 'boolean'
      },
      readOnly: {
        type: 'boolean'
      },
      value: {
        type: ['string', 'number', 'boolean']
      },
      parent: {
        type: 'string'
      }
    },
    additionalProperties: false
  }
};
const validateOptionalComponents = function () {
  let components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const validate = new _ajv.default({
    allowUnionTypes: true
  }).compile(COMPONENTS_SCHEMA);
  const valid = validate(components);
  if (!valid) {
    console.error('OptionalComponentsError', {
      message: 'Invalid OptionalComponents schema, return value will be ignored',
      errors: validate.errors
    });
  }
  return valid;
};
var _default = exports.default = validateOptionalComponents;